import ProjectCardParallax from './project_card_parallax';

export default ProjectCardParallax;
